import React, { useState } from 'react';
import './BlogPage.css';

function BlogPage() {
  const [searchTerm, setSearchTerm] = useState('');

  // Blog posts data with real sports images
  const blogPosts = [
    {
      id: 1,
      title: "Advanced Training Techniques for Professional Athletes",
      date: "February 15, 2024",
      category: "Training",
      comments: 3,
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop&crop=center",
      excerpt: "Discover the latest training methodologies that are revolutionizing how professional athletes prepare for competition. From high-intensity interval training to recovery protocols, learn what separates elite performers from the rest.",
      author: "Coach Mike Johnson"
    },
    {
      id: 2,
      title: "Nutrition Strategies for Peak Athletic Performance",
      date: "January 28, 2024",
      category: "Nutrition",
      comments: 7,
      image: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop&crop=center",
      excerpt: "Proper nutrition is the foundation of athletic success. Explore evidence-based dietary approaches that fuel performance, enhance recovery, and optimize body composition for competitive sports.",
      author: "Dr. Sarah Williams"
    },
    {
      id: 3,
      title: "Mental Conditioning: The Psychology of Winning",
      date: "January 12, 2024",
      category: "Psychology",
      comments: 5,
      image: "https://images.unsplash.com/photo-1566577739112-5180d4bf9390?w=400&h=300&fit=crop&crop=center",
      excerpt: "The mental game is just as important as physical preparation. Learn about visualization techniques, stress management, and mental toughness strategies used by championship athletes.",
      author: "Dr. James Rodriguez"
    },
    {
      id: 4,
      title: "Injury Prevention and Recovery Protocols",
      date: "December 20, 2023",
      category: "Health",
      comments: 12,
      image: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&h=300&fit=crop&crop=center",
      excerpt: "Stay in the game longer with proven injury prevention strategies and effective recovery techniques. From warm-up routines to rehabilitation protocols, keep your body performing at its best.",
      author: "Dr. Lisa Chen"
    },
    {
      id: 5,
      title: "Sports Technology: How Data is Changing the Game",
      date: "December 5, 2023",
      category: "Technology",
      comments: 8,
      image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=300&fit=crop&crop=center",
      excerpt: "From wearable devices to performance analytics, technology is transforming how athletes train and compete. Explore the latest innovations that are revolutionizing sports performance.",
      author: "Tech Specialist Alex Kim"
    },
    {
      id: 6,
      title: "Team Building and Leadership in Sports",
      date: "November 18, 2023",
      category: "Leadership",
      comments: 4,
      image: "https://images.unsplash.com/photo-1549719386-74dfcbf7dbed?w=400&h=300&fit=crop&crop=center",
      excerpt: "Great teams are built on strong leadership and effective communication. Learn how successful coaches and captains inspire their teams to achieve championship-level performance.",
      author: "Coach David Thompson"
    }
  ];

  const recentPosts = [
    "Advanced Training Techniques for Professional Athletes",
    "Nutrition Strategies for Peak Athletic Performance",
    "Mental Conditioning: The Psychology of Winning",
    "Injury Prevention and Recovery Protocols",
    "Sports Technology: How Data is Changing the Game"
  ];

  const categories = [
    "Training", "Nutrition", "Psychology", "Health", "Technology", "Leadership", "Equipment"
  ];

  const archives = [
    "February 2024", "January 2024", "December 2023", "November 2023", "October 2023", "September 2023"
  ];

  return (
    <div className="blog-page">
      {/* Main Content - Blog */}
      <main className="blog-main">
        <div className="container">
          <div className="blog-layout">
            {/* Main Content Area */}
            <div className="blog-content">
              <h1 className="blog-title">Sports Blog</h1>
              <p className="blog-subtitle">Insights, tips, and stories from the world of sports</p>
              
              <div className="blog-posts">
                {blogPosts.map((post) => (
                  <article key={post.id} className="blog-post">
                    <div className="post-image">
                      <img src={post.image} alt={post.title} className="post-img" />
                    </div>
                    <div className="post-content">
                      <h2 className="post-title">{post.title}</h2>
                      <div className="post-meta">
                        <span className="post-date">{post.date}</span>
                        <span className="post-separator">|</span>
                        <span className="post-comments">{post.comments} Comments</span>
                        <span className="post-separator">|</span>
                        <span className="post-category">{post.category}</span>
                      </div>
                      <p className="post-excerpt">{post.excerpt}</p>
                      <div className="post-author">By {post.author}</div>
                      <button className="read-more-btn">Read More</button>
                    </div>
                  </article>
                ))}
              </div>
            </div>

            {/* Sidebar */}
            <aside className="blog-sidebar">
              {/* Search */}
              <div className="sidebar-widget">
                <h3 className="widget-title">Search</h3>
                <div className="search-form">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  <button className="search-btn">
                    <span className="search-icon">🔍</span>
                  </button>
                </div>
              </div>

              {/* Recent Posts */}
              <div className="sidebar-widget">
                <h3 className="widget-title">Recent Posts</h3>
                <ul className="recent-posts">
                  {recentPosts.map((post, index) => (
                    <li key={index} className="recent-post-item">
                      <button className="recent-post-link">{post}</button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Categories */}
              <div className="sidebar-widget">
                <h3 className="widget-title">Categories</h3>
                <ul className="categories-list">
                  {categories.map((category, index) => (
                    <li key={index} className="category-item">
                      <button className="category-link">{category}</button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Archives */}
              <div className="sidebar-widget">
                <h3 className="widget-title">Archives</h3>
                <ul className="archives-list">
                  {archives.map((archive, index) => (
                    <li key={index} className="archive-item">
                      <button className="archive-link">{archive}</button>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </main>

      {/* Footer - Same as main page */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building. 
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <button className="view-more">View More...</button>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/" className="footer-link">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="/contact" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 123 Sports Avenue, Athletic District, City 12345</div>
                <div className="contact-item">📞 0123-456-789</div>
                <div className="contact-item">✉️ info@askmesportsalliance.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src="/assets/main logo.png" alt="Sports Alliance Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 AskMe Sports Alliance. Design & developed by Grace Themes
          </div>
        </div>
      </footer>
    </div>
  );
}

export default BlogPage;
